import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import Image01 from "../../../images/solution/stack/1.png";
import Image02 from "../../../images/solution/stack/2.png";
import Image03 from "../../../images/solution/stack/3.png";
import Image04 from "../../../images/solution/stack/4.png";
import Image05 from "../../../images/solution/stack/5.png";
import Image06 from "../../../images/solution/stack/6.png";
import Image07 from "../../../images/solution/stack/7.png";
import Image08 from "../../../images/solution/stack/8.png";
import {LazyLoadImage} from "react-lazy-load-image-component";

function Techstack(props) {
    return (
        <div className="p-100 tekrevol_gray_bg">
            <Container>
                <Row>
                    <Col xs={12} md={8} lg={8} xl={8} xxl={8}>
                        <div className="example" data-text="Tech Stack">
                            <h2>Our Technology-Stack</h2>
                        </div>
                        <p>At TekRevol, we use multiple technologies to develop software systems. These technologies and
                            languages may differ as per the requirements.</p>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
                        <div className="tech_images">
                            <div className="tech_item">
                                <div className="tech_img">
                                    <LazyLoadImage
                                        src={Image01}
                                        effect="blur" alt="Image01" className="img-fluid"
                                    />
                                </div>
                            </div>
                            <div className="tech_item">
                                <div className="tech_img">
                                    <LazyLoadImage
                                        src={Image02}
                                        effect="blur" alt="Image02" className="img-fluid"
                                    />
                                </div>
                            </div>
                            <div className="tech_item">
                                <div className="tech_img">
                                    <LazyLoadImage
                                        src={Image03}
                                        effect="blur" alt="Image03" className="img-fluid"
                                    />
                                </div>
                            </div>
                            <div className="tech_item">
                                <div className="tech_img">
                                    <LazyLoadImage
                                        src={Image04}
                                        effect="blur" alt="Image04" className="img-fluid"
                                    />
                                </div>
                            </div>
                            <div className="tech_item">
                                <div className="tech_img">
                                    <LazyLoadImage
                                        src={Image05}
                                        effect="blur" alt="Image05" className="img-fluid"
                                    />
                                </div>
                            </div>
                            <div className="tech_item">
                                <div className="tech_img">
                                    <LazyLoadImage
                                        src={Image06}
                                        effect="blur" alt="Image06" className="img-fluid"
                                    />
                                </div>
                            </div>
                            <div className="tech_item">
                                <div className="tech_img">
                                    <LazyLoadImage
                                        src={Image07}
                                        effect="blur" alt="Image07" className="img-fluid"
                                    />
                                </div>
                            </div>
                            <div className="tech_item">
                                <div className="tech_img">
                                    <LazyLoadImage
                                        src={Image08}
                                        effect="blur" alt="Image08" className="img-fluid"
                                    />
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
                        <div className="tech_listing">
                            <div className="tech_tit">
                                <h5>Products we deliver meet international security standards</h5>
                            </div>
                            <div className="tech_point">
                                <ul>
                                    <li>HIPAA</li>
                                    <li>HITECH</li>
                                    <li>TX-HB300</li>
                                    <li>CCHIT</li>
                                    <li>HL7</li>
                                    <li>CDA</li>
                                    <li>CCD</li>
                                    <li>CC</li>
                                </ul>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Techstack;